import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { blogsData } from "../constant";
import DOMPurify from "dompurify";

const BlogDetail = () => {
  // const [blog, setBlog] = useState(null);
  const [error, setError] = useState(null);

  const { id } = useParams();
  const blogIndex = blogsData.findIndex((blog) => blog.id === id);
  const blog = blogsData[blogIndex];

  // const fetchBlogById = async (id) => {
  //   try {
  //     const response = await fetch(`http://127.0.0.1:5000/api/blogs/${id}`);
  //     if (!response.ok) {
  //       throw new Error("Blog not found");
  //     }
  //     const blog = await response.json();
  //     return blog;
  //   } catch (error) {
  //     console.error("Error fetching blog:", error);
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   fetchBlogById(id)
  //     .then((data) => {
  //       if (data) {
  //         setBlog(data);
  //       } else {
  //         setError("Blog not found");
  //       }
  //     })
  //     .catch((err) => setError(err.message));
  // }, [id]);

  useEffect(() => {
    // Scroll to the top on blog change
    window.scrollTo(0, 0);
  }, [id]);

  if (!blog) {
    return (
      <>
        <NavBar />
        <div className="container mx-auto px-4 lg:px-20 pt-28 pb-12">
          <Helmet>
            <title>Blog Not Found - TeqnoDux</title>
            <meta name="description" content="This blog does not exist." />
          </Helmet>
          <h1 className="text-4xl font-bold text-center text-red-500">
            Blog Not Found
          </h1>
        </div>
        <Footer />
      </>
    );
  }

  const sanitizedContent = DOMPurify.sanitize(blog.content);

  // Get 3 random featured blogs excluding the current blog
  const featuredBlogs = blogsData
    .filter((featuredBlog) => featuredBlog.id !== blog.id)
    .sort(() => 0.5 - Math.random())
    .slice(0, 3);

  return (
    <>
      <NavBar />
      <Helmet>
        <title>{blog.title} - TeqnoDux</title>
        <meta name="description" content={blog.summary} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.summary} />
        <meta property="og:image" content={blog.image} />
        <meta
          property="og:url"
          content={`https://www.teqnodux.com/blogs/${blog.id}`}
        />
        <meta property="og:type" content="article" />
        <link
          rel="canonical"
          href={`https://www.teqnodux.com/blogs/${blog.id}`}
        />
      </Helmet>
      <div className="container mx-auto sm:px-4  px-8 lg:px-20 pt-28 pb-12">
        <h1 className="sm:text-4xl text-2xl font-bold text-center text-[#377c7d] mb-4">
          {blog.title}
        </h1>
        <img
          src={blog.banner || blog.image}
          alt={blog.title}
          className="w-full h-64 object-cover mb-8 rounded-lg"
        />
        <div
          className="text-gray-800 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
        <div className="mt-8">
          <p className="text-gray-600 italic">
            Tags:{" "}
            {blog.tags.map((tag, index) => (
              <span
                key={index}
                className="inline-block bg-gray-200 text-gray-700 px-2 py-1 rounded mr-2"
              >
                {tag}
              </span>
            ))}
          </p>
        </div>

        {/* Featured Blogs Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-[#377c7d] mb-8 text-center">
            Featured Blogs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {featuredBlogs.map((featuredBlog) => (
              <div
                key={featuredBlog.id}
                className="bg-white shadow-lg rounded-lg overflow-hidden"
              >
                <img
                  src={featuredBlog.image}
                  alt={featuredBlog.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <h3 className="text-2xl font-bold text-[#377c7d] mb-2">
                    {featuredBlog.title}
                  </h3>
                  <p className="text-gray-700">{featuredBlog.summary}</p>
                  <Link
                    to={`/blogs/${featuredBlog.id}`}
                    className="inline-block mt-4 text-white bg-[#377c7d] hover:bg-[#2b6262] px-4 py-2 rounded-lg"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetail;
